/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgReorderItem = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M6 2v2H2v18h8v-2H4V6h2v2h10V6h2v4h2V4h-4V2zm2 2h6v2H8zm9.53 8.152a1 1 0 0 0-1.06 0l-4 2.5a1 1 0 0 0-.47.848v4a1 1 0 0 0 .47.848l4 2.5a1 1 0 0 0 1.06 0l4-2.5A1 1 0 0 0 22 19.5v-4a1 1 0 0 0-.47-.848zM16 20.196l-2-1.25v-1.642l2 1.25zm4-2.892v1.642l-2 1.25v-1.642zm-.887-1.804L17 16.82l-2.113-1.32L17 14.18z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgReorderItem as ReorderItem };
